/* global globalThis */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Avatar,
  Modal
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationBar from "./NotificationBar";
import { useDispatch, useSelector } from "react-redux";
import LanguageSwitcher from "./LanguageSwitcher";
import {
  useStyles as useStylesForSdk,
  useTranslations,
} from "examsbook-react-sdk/custom-hooks";
import NotificationScreen from "../../PaymentSection/NotificationScreen";
import "./Header.scss";
import { useSearchQuery } from "../../../services/SearchQueryContext";
import { ReactComponent as SearchIcon } from "../../../assets/images/search.svg";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import MobileViewSideBar from "./MobileViewSideBar";
import { ReactComponent as CrossIcon } from "../../../assets/images/close.svg";
import { useTheme } from "../../../constants/themeProvider";
import Tooltip from "@material-ui/core/Tooltip";
import BrandLogo from "../../../assets/images/LearnifyLogoLight.png";
import NotificationsIcon from '@material-ui/icons/Notifications';
import status from "examsbook-react-sdk/constants/actionStatus.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { LinearProgressWithLabel } from "../../Tabs/SelfLearningCard";
import { setSelfLearningTabAction } from "examsbook-react-sdk/actions/getCourses";
import { getSelfLearningAction } from "examsbook-react-sdk/actions/getSelfLearningAction";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    appBar: {
      width: "100%",
    },
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },

  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  hide: {
    display: "none",
  },

  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}));
const drawerWidth = 300;
const REPORTS_ROUTE_REGEX = /^\/reports\/[^/]+\/[^/]+$/;
const SEARCHABLE_PATHS = new Set([
  "/courses",
  "/surveys",
  "/support-ticket",
  "/my-courses",
  "/course-package",
  "/certificate-list",
]);
const MOBILE_DEFAULT_TEXT_CLASS_PATHS = new Set([
  "/surveys",
  "/support",
  "/support-ticket",
  "/certificate-list",
  "/notifications",
]);

const getStaticHeaderTitle = (pathname, courseId, t) => {
  const titleByPath = {
    "/courses": t("All Courses"),
    "/my-courses": t("My Courses"),
    "/course-package": t("Course Package"),
    "/surveys": t("Surveys"),
    "/support": t("New Support Ticket"),
    "/support-ticket": t("Support Ticket"),
    "/certificate-list": t("My Certificates"),
    "/notifications": t("Notifications"),
    "/my-profile": t("my_profile"),
  };

  if (pathname === `/course/leaderboard/${courseId}`) {
    return t("Leaderboard");
  }

  return titleByPath[pathname] || "";
};

const getSavedMenuLabel = (savedMenu, t) => {
  if (savedMenu === "/courses") {
    return t("All Courses");
  }
  if (savedMenu === "/course-package") {
    return t("Course Package");
  }
  return t("MY_COURSES");
};

function CHeaderBarContent(props) { // NOSONAR
  const headerRootRef = useRef(null);
  const { open, openFeedbackModel } = props;
  const t = useTranslations();
  const user = useSelector((state) => state.user);
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const userImage = user?.user?.image ? user?.user?.image : user?.image;
  const theme = useTheme();

  const [refresh, setRefresh] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [mySectionData, setMySectionData] = useState("");
  const { searchQuery, setSearchQuery } = useSearchQuery();
  const [isMobile, setIsMobile] = useState(false);
  const [openToggler, setOpenToggler] = useState(false);
  const [dynamicLogos, setDynamicLogos] = useState("");
  const settings = useSelector((state) => state.settingsReducers);
  const isLoadingSettings = settings.status === status.PENDING;
  const settingsData = settings.settingsData?.data || [];

  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const pathname = location.pathname;
  const isReportsRoute = REPORTS_ROUTE_REGEX.test(pathname);

  const learningData = useSelector((state) => state.selfLearningReducers);
  const selfLearningData = learningData?.selfLearningData;
  const courseName = useSelector((state) => state.filteredCourseList.courseName) || location?.state?.courseName || location?.state?.subjectDetail?.courseId?.name || mySectionData?.data?.courseId?.name;
  const showEvaluationTest = useSelector((state) => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
  const showInstructions = useSelector((state) => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;
  const isVisible = useSelector((state) => state?.bottomBarReducer?.isVisible);
  const filterCourseId = pathname.split("/");
  const courseIdFromLocation = filterCourseId[filterCourseId.length - 1];
  const courseId = useSelector((state) => state.filteredCourseList.courseId) || location?.state?.courseId || courseIdFromLocation;
  const savedMenu = localStorage.getItem("selectedMenu");
  const courseProgress = useSelector((state) => state.filteredCourseList.courseProgress) || selfLearningData?.data?.progressPercent || location?.state?.courseProgress;

  const staticHeaderTitle = getStaticHeaderTitle(pathname, courseId, t);
  const isSearchEnabled = SEARCHABLE_PATHS.has(pathname);
  const savedMenuLabel = getSavedMenuLabel(savedMenu, t);

  useEffect(() => {
    if (!headerRootRef.current) {
      return;
    }

    headerRootRef.current.style.setProperty(
      "--header-primary-color",
      theme?.primaryColor || "#0c3450"
    );
  }, [theme]);

  const toggleDrawer = (isOpen) => {
    setOpenToggler(isOpen);
  };

  useEffect(() => {
    function handleResize() {
      setIsMobile(globalThis.innerWidth <= 959);
    }

    globalThis.addEventListener("resize", handleResize);
    handleResize();

    return () => globalThis.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile && showEvaluationTest !== undefined && courseIdFromLocation && showEvaluationTest) {
      dispatch(getSelfLearningAction(courseIdFromLocation)).then((res) => {
        setMySectionData(res);
      });
    }
  }, [courseIdFromLocation, dispatch, isMobile, showEvaluationTest]);

  useEffect(() => {
    if (!isLoadingSettings) {
      const imageValue = settingsData?.data?.[0]?.branding?.logos?.webAndAppLogo?.imagePath;
      setDynamicLogos(imageValue || BrandLogo);
    }
  }, [isLoadingSettings, settingsData]);

  const handleMenu = () => {
    history.push("/my-profile");
  };

  const handleClose = () => {
    setOpenModal(false);
    setRefresh(!refresh);
  };

  const goToCourse = () => {
    history.push(`/course/${courseId}`, {
      courseId,
      subjectId: "",
      topicId: "",
      subjectDetail: "",
      subjectName: "",
      topicName: "",
      courseName,
      showEvaluationTest,
      showInstructions,
      courseProgress,
    });
  };

  const classesList = useStylesForSdk(styles)();

  const [currentTime, setCurrentTime] = useState(new Date());
  const hour = currentTime.getHours();

  let greeting = `${t("Good Morning")}`;
  if (hour >= 12 && hour < 16) {
    greeting = `${t("Good Afternoon")}`;
  } else if (hour >= 16) {
    greeting = `${t("Good Evening")}`;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const clearField = () => {
    if (searchQuery.length) {
      setSearchQuery("");
    }
  };

  const handleNavigation = () => {
    history.push("/dashboard");
  };

  const goToCourseScreen = () => {
    if (savedMenu === "/courses") {
      history.push("/courses");
      return;
    }

    if (savedMenu === "/course-package") {
      history.push("/course-package");
      return;
    }

    history.push("/my-courses", { params: pathname });
  };

  const goBack = () => {
    dispatch(setSelfLearningTabAction(true));
    if (isReportsRoute) {
      goToCourse();
    }
  };

  const renderReportsTitle = () => (
    <Box className={classesList.reportsHeader}>
      <ArrowBackIcon className="clickable-icon" onClick={goBack} />
      <Typography variant="inherit" color="inherit" className={classesList.courseNameText}>
        <Tooltip title={courseName} aria-label="add">
          <Typography variant="inherit">{courseName}</Typography>
        </Tooltip>
      </Typography>
    </Box>
  );

  const renderMobileHeaderContent = () => {
    if (isReportsRoute) {
      return (
        <Box className="mobile-reports-title-box">
          <Typography variant="inherit" color="inherit" className="mobile-reports-title-text">
            <Tooltip title={courseName} aria-label="add">
              <Typography variant="inherit">{courseName}</Typography>
            </Tooltip>
          </Typography>
        </Box>
      );
    }

    if (staticHeaderTitle) {
      const className = MOBILE_DEFAULT_TEXT_CLASS_PATHS.has(pathname) ? "greeting-text" : "greeting-text-mobile";
      return <Typography className={className}>{staticHeaderTitle}</Typography>;
    }

    if (!isVisible && pathname !== "/dashboard") {
      return (
        <Typography className="greeting-text-mobile mobile-saved-menu-label" variant="inherit" color="inherit" onClick={goToCourseScreen}>
          {savedMenuLabel}
        </Typography>
      );
    }

    if (!isLoadingSettings && dynamicLogos && !isVisible) {
      return <Box component="img" src={dynamicLogos} className="brand-header-logo" onClick={handleNavigation} />;
    }

    return null;
  };

  const renderDesktopHeaderContent = () => {
    if (isReportsRoute) {
      return renderReportsTitle();
    }

    if (staticHeaderTitle) {
      return <Typography className="greeting-text">{staticHeaderTitle}</Typography>;
    }

    return (
      <Typography className="greeting-text">
        {greeting}, <Typography variant="inherit">{userName}</Typography>
      </Typography>
    );
  };

  return (
    <Toolbar
      ref={headerRootRef}
      disableGutters={!open}
      className={`main-header-section ${isMobile ? "mobile-no-shadow" : ""}`}
      id="mainHeaderSectionId"
    >
      {isMobile ? (
        <>
          <AppBar className="mobile-app-bar mobile-no-shadow">
            <Toolbar className="mobile-toolbar-flex">
              <Box className="mobile-toolbar-icon-box">
                {!isVisible && !isReportsRoute ? (
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    onClick={() => toggleDrawer(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                ) : (
                  <ArrowBackIcon className="clickable-icon" onClick={goBack} />
                )}
              </Box>

              <Box className="text-box-mobile">
                <Typography className="greeting-text-mobile">
                  {greeting}, <Typography variant="inherit">{userName}</Typography>
                </Typography>
              </Box>

              {renderMobileHeaderContent()}

              {isVisible ? (
                <Box className={classesList.headerCourseNameBox}>
                  <Typography className="greeting-course-name ellipsis-course-name">
                    {courseName}
                  </Typography>
                  <Box className="mobile-course-progress-text">
                    <LinearProgressWithLabel value={courseProgress} />
                  </Box>
                </Box>
              ) : (
                <Box className="mobile-notification-screen">
                  {!isReportsRoute && (
                    <IconButton onClick={() => history.push("/notifications")}>
                      <NotificationsIcon />
                    </IconButton>
                  )}
                </Box>
              )}

              <Box className="hidden-account-box">
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  <Avatar
                    src={userImage}
                    alt="user image"
                    className={`my-image header-user-avatar ${userImage ? "" : "header-user-avatar-fallback"}`}
                  />
                  <Box id="contentBlockId" className={`header-content-block ${isMobile ? "header-content-block-hidden" : ""}`}>
                    <p id="contentId">{userName}</p>
                  </Box>
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          <MobileViewSideBar
            openToggler={openToggler}
            toggleDrawer={toggleDrawer}
            openFeedbackModel={openFeedbackModel}
            classes={classes}
            user={user}
          />
        </>
      ) : (
        <>
          <Box className="text-box header-desktop-text-box">
            {renderDesktopHeaderContent()}

            {isSearchEnabled && (
              <Box className="outer-search-box">
                <input
                  className="search-box"
                  type="text"
                  placeholder={t("Search")}
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                />
                <Box className="search-img-box">
                  {searchQuery.length ? (
                    <button
                      onClick={clearField}
                      className="header-search-clear-btn"
                    >
                      <CrossIcon className="cross-icon" alt="Cross Icon" />
                    </button>
                  ) : (
                    <SearchIcon className="search-icon" alt="Search Icon" />
                  )}
                </Box>
              </Box>
            )}
          </Box>
          {!isReportsRoute && (
            <Box className="notification-bar">
              <NotificationBar openFeedbackModel={openFeedbackModel} />
              <Box className="mobile-language-header-new">
                <Box component="ul" className="right-menus-new">
                  <Box component="li" className="">
                    <LanguageSwitcher />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </>
      )}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        BackdropProps={{ className: "header-modal-backdrop" }}
        className={classesList.modal}
      >
        <Box className={classesList.box}>
          <Box className={classesList.inside}>
            <NotificationScreen
              refresh={refresh}
              setRefresh={() => setRefresh(!refresh)}
            />
          </Box>
        </Box>
      </Modal>
    </Toolbar>
  );
}

CHeaderBarContent.propTypes = {
  open: PropTypes.bool,
  openFeedbackModel: PropTypes.func,
};

const styles = (theme) => ({
  box: {
    backgroundColor: "white",
    position: "absolute",
    top: "65px",
    right: "70px",
    boxShadow: theme.shadows[4],
  },
  inside: {
    overflowY: "scroll",
    maxHeight: "570px",
    width: "460px",
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  headerCourseNameBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '0px 10px',
    "@media (max-width: 500px)": {
      padding: '0px 4px',
      gap: '4px'
    }
  },
  courseNameText: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#202020'
  },
  reportsHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }
});

export default CHeaderBarContent;
